import type { catalog as catalogEn } from "../en/catalog";

export const catalog: typeof catalogEn = {
  continents: {
    asia: "Asie",
    africa: "Afrika",
    southAmerica: "Jižní Amerika",
    northAmerica: "Severní Amerika",
    oceania: "Austrálie a Oceánie",
    europe: "Evropa",
  },
  months: {
    jan: "Led",
    feb: "Úno",
    mar: "Bře",
    apr: "Dub",
    may: "Kvě",
    jun: "Čvn",
    jul: "Čvc",
    aug: "Srp",
    sep: "Zář",
    oct: "Říj",
    nov: "Lis",
    dec: "Pro",
  },
  confirmDeleteNamed: "Opravdu chcete smazat „{{name}}“? Tuto akci nelze vrátit zpět.",
  basicInfo: "Základní informace",
  urlSlug: "URL slug",
  photo: "Fotografie",
  destinations: {
    list: {
      title: "Destinace",
      subtitle: "Správa destinací zájezdů",
      new: "Nová destinace",
      searchPlaceholder: "Hledat destinace…",
      allContinents: "Všechny kontinenty",
      loadError: "Destinace se nepodařilo načíst. Zkuste to prosím znovu.",
      empty: "Žádné destinace nenalezeny",
      facetCountry: "Země",
      facetLevel: "Úroveň",
      levelCountry: "Země",
      levelPlace: "Lokalita",
      colContinent: "Kontinent",
      featured: "Doporučená",
      standard: "Standardní",
      facetNav: "Nabídka destinací",
      navShown: "V menu",
      navHidden: "Mimo menu",
      navToggleTitle:
        "Přepnout, jestli se destinace nabízí v menu, ve filtru zájezdů a v hledání na úvodní stránce",
    },
    edit: {
      newTitle: "Nová destinace",
      editTitle: "Upravit destinaci",
      newSubtitle: "Vytvořte novou destinaci",
      editingSubtitle: "Úprava: {{name}}",
      loadFailed: "Destinaci se nepodařilo načíst",
      unknownError: "Neznámá chyba",
      backToList: "Zpět na destinace",
      tabs: {
        basic: "Základní",
        content: "Obsah",
        practical: "Praktické info",
        cuisine: "Tipy, aktivity a výhody",
        media: "Média",
        faq: "FAQ",
        offer: "Nabídka",
        related: "Související",
      },
    },
    featuredImage: "Hlavní obrázek",
    basic: {
      namePlaceholder: "např. Vietnam",
      slugPlaceholder: "např. vietnam",
      continent: "Kontinent",
      parent: "Nadřazená destinace",
      parentNone: "Žádná (nejvyšší úroveň)",
      parentInfoText: "Text infoboxu o zemi",
      parentInfoTextPlaceholder: "např. Hoi An leží ve středním Vietnamu…",
      assignedGuide: "Přiřazený průvodce",
      noGuide: "Bez průvodce",
      assignedGuideHintLink: "Kontakty a týmy →",
      latitude: "Zeměpisná šířka (GPS)",
      longitude: "Zeměpisná délka (GPS)",
      latRange: "Musí být mezi -90 a 90",
      lngRange: "Musí být mezi -180 a 180",
      latHint: "-90 až 90",
      lngHint: "-180 až 180",
      latPlaceholder: "např. 16.0544",
      lngPlaceholder: "např. 108.2022",
      heroPlaceholder: "např. Objevte Vietnam",
      headingPlaceholder: "např. Vietnam – objevte esenci jihovýchodní Asie",
      shortDescriptionTitle: "Krátký popis (pro vyhledávače a náhledy)",
      shortDescription: "Krátký popis",
      shortDescriptionPlaceholder: "Vietnam – esence Asie…",
      climateTitle: "Klima a nejlepší doba návštěvy",
      climate: "Klima",
      climatePlaceholder: "např. tropické monzunové",
      bestTime: "Nejlepší doba návštěvy",
      bestTimePlaceholder: "např. únor – červen",
      descriptionTitle: "Popis destinace",
      descriptionPlaceholder: "Podrobný popis destinace…",
      seoTitle: "SEO",
      metaTitle: "Meta titulek",
      metaTitlePlaceholder: "SEO titulek",
      metaDescription: "Meta popis",
      metaDescriptionPlaceholder: "Krátký popis pro vyhledávače (max 160 znaků)",
      defaultMinPax: "Výchozí počet osob pro kalkulace",
      autoRouteLeads: "Automaticky směrovat poptávky",
      showAsFeatured: "Zobrazit jako doporučenou",
      showInNav: "Nabízet v menu a filtrech",
      showAsCountry: "Zobrazovat jako zemi",
    },
    content: {
      testimonialTitle: "Zákaznická reference",
      quote: "Citace",
      quotePlaceholder: "Citace z reference zákazníka…",
      author: "Autor / titulek",
      authorPlaceholder: "např. Víme, že jsme vše zařídili perfektně",
      authorImage: "Fotografie autora",
      backgroundImage: "Obrázek na pozadí",
      additionalTitle: "Doplňkový obsah",
      additionalText: "Doplňkový text",
      additionalTextPlaceholder: "Další obsah o destinaci…",
      additionalImage: "Doplňkový obrázek",
    },
    practical: {
      title: "Praktické informace",
      visa: "Víza",
      visaPlaceholder: "Informace o vízech…",
      currencyPlaceholder: "např. vietnamský dong (VND)",
      language: "Jazyk",
      languagePlaceholder: "např. vietnamština",
      timezone: "Časové pásmo",
      timezonePlaceholder: "např. UTC+7",
      electricity: "Elektřina",
      electricityPlaceholder: "např. 220 V, typ A/C/G",
      vaccination: "Očkování",
      vaccinationPlaceholder: "Doporučená očkování…",
      weatherTitle: "Počasí (měsíční mřížka)",
      cycleHint: "Klikáním přepínáte: vypnuto → nejlepší (zelená) → dobré (oranžová) → vypnuto",
      temperaturesTitle: "Teploty po měsících",
      airTemp: "Vzduch °C",
      waterTemp: "Voda °C",
      tempLegend: "Vlevo = vzduch °C, vpravo = voda °C",
      weatherDescription: "Popis počasí",
      weatherDescriptionPlaceholder: "Popište celkové klima a nejlepší dobu návštěvy…",
      localTip: "Místní tip",
      localTipPlaceholder:
        "Krátká praktická rada zobrazená pod klimatem, např. památky plánujte na dopoledne…",
      monthlyTitle: "Text o počasí pro jednotlivé měsíce",
      monthlyPlaceholder: "Jaké je počasí v měsíci {{month}}?",
    },
    cuisine: {
      gastronomyTitle: "Kde se dobře najíst (Užitečné tipy)",
      description: "Text tipu",
      descriptionPlaceholder: "Vietnamská kuchyně je proslulá svou čerstvostí…",
      activitiesTitle: "Aktivity",
      activitiesDescription: "Přidejte aktivity, které lze v této destinaci zažít",
      activitiesPlaceholder: "např. plavba zátokou Ha Long",
      activitiesEmpty: "Zatím žádné aktivity",
      whyWithUsTitle: "Proč cestovat s námi",
      whyWithUsPlaceholder: "např. Máme vlastní česky mluvící průvodce v Hanoji.",
      whyWithUsTitlePlaceholder: "Nadpis karty (nepovinný)",
      whyWithUsIconLabel: "Piktogram",
      whyWithUsEmpty: "Zatím žádné výhody",
      whyWithUsIcons: {
        check: "Odškrtnutí",
        guide: "Průvodce",
        group: "Skupina",
        briefcase: "Kufřík",
        map: "Mapa",
        heart: "Srdce",
        star: "Hvězda",
        shield: "Štít",
        support: "Telefon",
        tip: "Žárovka",
      },
    },
    media: {
      gallery: "Galerie",
      socialReels: "Reels ze sociálních sítí (sekce Nechte se inspirovat)",
      videoBlock: "Video destinace",
      videoUrl: "Adresa videa (YouTube nebo Instagram)",
      videoUrlHint: "Video se přehraje v okně na stránce až po souhlasu s cookies.",
      videoTitle: "Nadpis",
      titlePlaceholder: "např. VIETNAM SPECIÁL: tipy od A do Z",
      videoDescription: "Popis",
      videoDescriptionHint: "Pište krátce, celý text z YouTube sem nepatří.",
      descriptionPlaceholder: "Krátký popis do sekce videa…",
      thumbnail: "Náhled (16 : 9)",
      thumbnailHint: "Použijte širokou fotku, snímek z YouTube se rozmaže.",
      moreVideosUrl: "Odkaz na další videa",
      moreVideosUrlHint: "Celá adresa začínající https://, např. playlist na YouTube.",
      moreVideosUrlInvalid: "Zadejte celou adresu začínající https:// (nejvýš 500 znaků).",
    },
    faq: {
      title: "Časté dotazy destinace",
    },
    offer: {
      title: "Obsah nabídkových stránek",
      hint: "Úvodní text a časté dotazy pro výpis zájezdů této destinace. Ukládají se zvlášť pro každou plochu — „Všechny typy“ patří adrese bez zvoleného typu, ostatní jejím typovým variantám.",
      allTypes: "Všechny typy",
      introLabel: "Úvodní text",
      introPlaceholder: "např. Do Japonska vozíme poznávací okruhy s českým průvodcem…",
      faqLabel: "Časté dotazy",
      statusTitle: "Stav indexace",
      statusLoading: "Načítám počty zájezdů…",
      statusFailed: "Počty zájezdů se nepodařilo načíst.",
      statusNew: "Stav indexace se ukáže po prvním uložení destinace.",
      tripCountLabel: "Zájezdů v kombinaci",
      introCharsLabel: "Délka úvodního textu (znaky)",
      verdictYes: "Bude v indexu a v sitemapě",
      verdictNo: "Nebude v indexu ani v sitemapě",
      missingLabel: "Chybí:",
      reasonTrips: "málo zájezdů: {{count}} z potřebných {{min}}",
      reasonIntro: "krátký úvodní text: {{count}} z potřebných {{min}} znaků",
      unpublished:
        "Destinace není publikovaná, takže její nabídková adresa zatím vrací 404 a práh se na ni neuplatní — počty proto zůstávají nulové. Obsah si tu můžete napsat dopředu.",
      planningTitle: "Plánovací blok",
      planningVariantLabel: "Varianta",
      planningDefault: "Výchozí text webu",
      planningVariantOption: "Varianta {{n}}",
      planningPreviewLabel: "Náhled",
      planningPreviewDefault: "Web použije výchozí znění.",
      planningPreviewEmpty: "Varianta {{n}} nemá v Nastavení text — web použije výchozí znění.",
      planningPreviewFailed: "Texty variant se nepodařilo načíst.",
      planningOwnText: "Vlastní text (přebije variantu)",
      planningOwnTextHint: "Prostý text. Prázdné = platí vybraná varianta.",
    },
    related: {
      tripsTitle: "Zájezdy do této destinace",
      tripsHint:
        "Přehled zájezdů, které mají tuhle destinaci jako hlavní. Přiřazení se dělá v zájezdu (pole Destinace a štítky destinací) — proto je tady jen ke čtení.",
      tripsSearchPlaceholder: "Hledat zájezdy…",
      tripsEmpty: "Do této destinace zatím nemíří žádný zájezd.",
      inspirationsTitle: "Inspirace v této destinaci",
      inspirationsPickerLabel: "Přiřazené inspirace",
      inspirationsSearchPlaceholder: "Hledat inspirace…",
      tripsLoadFailed: "Zájezdy se nepodařilo načíst.",
      inspirationsLoadFailed: "Inspirace se nepodařilo načíst.",
    },
    highlights: {
      title: "Hlavní atrakce",
      subtitle: "Přidejte nejzajímavější místa a zážitky v této destinaci",
      add: "Přidat atrakci",
      empty: "Zatím žádné atrakce",
      addFirst: "Přidat první atrakci",
      itemFallback: "Atrakce {{number}}",
      namePlaceholder: "např. zátoka Ha Long",
      descriptionPlaceholder: "Krátký popis atrakce…",
    },
    regions: {
      title: "Regiony",
      subtitle: "Přidejte jednotlivé oblasti destinace",
      add: "Přidat region",
      empty: "Zatím žádné regiony",
      addFirst: "Přidat první region",
      itemFallback: "Region {{number}}",
      namePlaceholder: "např. severní Vietnam",
      descriptionPlaceholder: "Podrobný popis regionu…",
    },
    stringArray: {
      placeholder: "Zadejte text…",
      empty: "Zatím žádné položky",
      add: "Přidat položku",
    },
  },
  guides: {
    list: {
      title: "Průvodci",
      subtitle: "Správa průvodců zájezdů",
      new: "Nový průvodce",
      searchPlaceholder: "Hledat průvodce…",
      loadError: "Průvodce se nepodařilo načíst. Zkuste to prosím znovu.",
      empty: "Žádní průvodci nenalezeni",
    },
    edit: {
      newTitle: "Nový průvodce",
      editTitle: "Upravit průvodce",
      namePlaceholder: "např. Jan Novák",
      slugPlaceholder: "např. jan-novak",
      yearsExperience: "Počet let zkušeností",
      location: "Bydliště",
      locationPlaceholder: "Ho Či Minovo Město, Vietnam",
      bioTitle: "Biografie",
      bioLabel: "Medailonek",
      bioPlaceholder: "Krátký medailonek průvodce…",
      specializations: "Specializace",
      specializationsPlaceholder: "Asie, treking, potápění",
      specializationsHint: "Oddělujte čárkami",
      homeDestination: "Domovská destinace",
      homeDestinationNone: "— žádná —",
      activeGuide: "Aktivní průvodce",
    },
  },
  teams: {
    sections: {
      guarantor: "Garant",
      salesTeam: "Prodejní tým",
      guide: "Průvodce",
      localTeam: "Místní tým",
      flightBooking: "Letenky",
      management: "Vedení",
      branchManager: "Vedoucí pobočky",
    },
    list: {
      title: "Kontakty a týmy destinací",
      subtitle:
        "Jméno, role, telefon a e-mail lidí, kteří se zákazníkům ukážou v sekci „Kontaktujte naše specialisty“ u destinace, lokality, inspirace i zájezdu.",
      new: "Nová týmová sekce",
      searchPlaceholder: "Hledat podle jména nebo destinace…",
      allTypes: "Všechny typy",
      loadError: "Týmy destinací se nepodařilo načíst. Zkuste to prosím znovu.",
      empty: "Žádné týmové sekce nenalezeny",
      noDestination: "Bez destinace — na webu se neukáže",
    },
    edit: {
      newTitle: "Nová týmová sekce",
      editTitle: "Upravit týmovou sekci",
      namePlaceholder: "např. Jan Novák",
      sectionType: "Typ sekce",
      destinationsLabel: "Destinace, kde se karta ukáže",
      destinationsSearch: "Hledat zemi…",
      noDestinationHint:
        "Bez vybrané destinace se karta neukáže na žádné stránce webu — zůstane jen tady v adminu.",
      primaryDestination: "Hlavní — telefon z pole Telefon: {{phone}}",
      phoneOverride: "Jiný telefon pro tuhle destinaci",
      memberPhonePlaceholder: "Telefon člena (volitelné)",
      memberEmailPlaceholder: "E-mail člena (volitelné)",
      subtitleRole: "Podtitulek / role",
      subtitlePlaceholder: "např. Garant destinace Vietnam",
      emailPlaceholder: "např. jana@ckgo2.cz",
      phonePlaceholder: "např. +420 793 950 220",
      bioTitle: "Biografie / popis",
      bioPlaceholder: "Řekněte nám něco o této osobě nebo týmu…",
      membersTitle: "Členové týmu",
      addMember: "Přidat člena",
      membersHint: "U týmových sekcí (prodejní tým, místní tým) uveďte jednotlivé členy týmu.",
      membersEmpty: "Zatím žádní členové",
      rolePlaceholder: "Role (volitelné)",
      galleryTitle: "Fotogalerie",
      uploadTeamPhotos: "Nahrát týmové fotografie",
      mainPhoto: "Hlavní fotografie",
      sortOrderHint: "Nižší = vyšší priorita",
      activeVisible: "Aktivní (viditelné na webu)",
    },
  },
  countryKb: {
    list: {
      title: "Znalosti zemí",
      subtitle:
        "Fakta o vízech, pasech, příletových kartách a sezónnosti — plní nabídky, předodletový balíček a AI prodejní vrstvu.",
      new: "Nová země",
      colCountry: "Země",
      colCode: "Kód",
      colVisa: "Víza",
      colArrivalCard: "Příletová karta",
      empty: "Zatím žádné země.",
      visaPolicies: {
        visaFree: "Bez víza",
        onArrival: "Po příletu",
        eVisa: "E-vízum",
        embassy: "Ambasáda",
      },
    },
    edit: {
      newTitle: "Nová země",
      fallbackTitle: "Země",
      subtitle: "Strukturovaná fakta — nabídky, předodletový balíček a AI je čtou jako data.",
      countryCode: "Kód země (ISO-2)",
      twoLetters: "2 písmena",
      countryName: "Název země",
      visaTitle: "Víza",
      policy: "Vízový režim",
      unknown: "— Neznámé —",
      policyVisaFree: "Bez víza",
      policyOnArrival: "Vízum po příletu",
      policyEVisa: "E-vízum",
      policyEmbassy: "Vízum na ambasádě",
      visaFreeDays: "Dní bez víza",
      fee: "Poplatek",
      feePlaceholder: "25 USD (jednovstupé e-vízum)",
      officialUrl: "Oficiální URL",
      visaNotesPlaceholder: "Postup žádosti, doba vyřízení, pravidla pro více vstupů…",
      passportHealthTitle: "Pas a zdraví",
      passportMinValidity: "Min. platnost pasu (měsíce)",
      vaccination: "Očkování",
      vaccinationPlaceholder: "Žádné povinné; doporučena hepatitida A/B",
      healthNotes: "Zdravotní poznámky",
      arrivalCardTitle: "Příletová karta",
      arrivalNone: "Žádná",
      arrivalOnArrival: "Papírová po příletu",
      arrivalOnline: "Online formulář",
      opensDaysBefore: "Otevírá se (dní předem)",
      formUrl: "URL formuláře",
      entryEngineTitle: "Entry engine",
      entryEngineHint:
        "Řídí frontu podání za jednotlivé cestující na termínech. Automatické podávání zůstává vypnuté, dokud není browser flow pro tuto zemi ověřen (Blok 5.4 PoC).",
      groupSubmission: "Skupinové podání (osob)",
      groupSubmissionHint: "TDAC/SGAC 10; portály po jednotlivcích 1",
      visaTaskOpens: "Úkol víza se otevírá (dní předem)",
      visaTaskOpensHint: "předstih pro e-vízum",
      filingChannel: "Kanál podání",
      channelManual: "Ručně (operátor)",
      channelBrowser: "Prohlížeč (autopilot)",
      extraArtifacts: "Další podklady",
      commaSeparated: "oddělené čárkami",
      autoFiling: "Automatické podávání zapnuto (vyžaduje kanál prohlížeče + souhlas klienta)",
      seasonalityTitle: "Sezónnost",
      seasonalityHint:
        "Klikáním na měsíc přepínáte nejlepší → dobré → špatné → nenastaveno. AI podle toho navrhuje lepší měsíc, když poptávka míří do špatné sezóny.",
      cycleTitle: "Klikáním přepínáte nejlepší → dobré → špatné → nenastaveno",
      seasonNotePlaceholder: "proč (např. období sucha)",
      scoreBest: "nejlepší",
      scoreGood: "dobré",
      scorePoor: "špatné",
      practicalTitle: "Praktické",
      currencyPlaceholder: "VND; karty běžné ve městech, jinde hotovost",
      plugs: "Zásuvky",
      tipping: "Spropitné",
      tippingPlaceholder: "Neočekává se; průvodci ocení ~5 USD/den",
      safetyNotes: "Bezpečnostní poznámky",
      practicalNotes: "Praktické poznámky",
      practicalNotesPlaceholder: "SIM karty, doprava, dress code…",
    },
  },
};
